// Get Variant ID from URL and select the radio button
function selectRadioButtonBasedOnURL() {
  let pageURL = window.location.href;
  if (pageURL.includes("?variant")) {
    let requiredCharacterIndex = pageURL.indexOf("?variant");
    let requiredURLSubstring = pageURL.substring(
      requiredCharacterIndex,
      pageURL.length
    );

    let finalQueryId = Number(requiredURLSubstring.replace("?variant=", ""));

    let allInputElements = document.querySelectorAll("input[prd-id]");
    allInputElements.forEach((item) => {
      let productID = Number(item.getAttribute("prd-id"));
      // console.log('Sahrudh  ' + productID);
      // console.log(finalQueryId);
      if (finalQueryId == productID) {
        item.checked = true;
        item.parentElement.classList.add("currently_active_input_parent");
      } else {
        item.checked = false;
        item.parentElement.classList.remove("currently_active_input_parent");
      }
      // if(productID == finalQueryId){
      //   item.checked = true
      //   alert(item.parentElement);
      // }
    });
  }
}